import React from 'react';

import { Box, Typography, CircularProgress } from '@mui/material';

interface CircularProgressWithLabelProps {
  startCount: number;
  currentCount: number;
}
export const CircularProgressWithLabel: React.FC<
  CircularProgressWithLabelProps
> = (props) => {
  const { startCount, currentCount } = props;

  const progress = (currentCount / startCount) * 100;
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant='determinate' value={progress} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant='caption' component='div' color='text.secondary'>
          {`${currentCount}`}
        </Typography>
      </Box>
    </Box>
  );
};
